import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';

import {
  STATISTICS_PATH,
  statisticsRoutesConfig,
} from 'domains/statistics/routes';
import { resetRedirectURL } from 'modules/auth/store/authSlice';
import { useAppDispatch } from 'store/useAppDispatch';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { usePartnerClientStatus } from 'domains/jwtToken/hooks/usePartnerClientStatus';
import { PATH_SETTINGS } from 'domains/userSettings/Routes';
import { PATH_TEAMS } from 'domains/teams/routes';

export const useRedirectToStatisticsForPartners = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isLoggedIn } = useAuth();

  const { isPartnerClient, isPartnerStatusLoading } = usePartnerClientStatus();

  const isStatisticsRoute =
    STATISTICS_PATH.includes(pathname) || pathname.includes(STATISTICS_PATH);
  const isSettingsPath = pathname.includes(PATH_SETTINGS);
  const isTeamsPath = pathname.includes(PATH_TEAMS);

  const shouldRedirect =
    isLoggedIn &&
    isPartnerClient &&
    !isPartnerStatusLoading &&
    !isStatisticsRoute &&
    !isSettingsPath &&
    !isTeamsPath;

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (shouldRedirect) {
      navigate(statisticsRoutesConfig.statistics.generatePath());

      dispatch(resetRedirectURL());
    }
  }, [dispatch, navigate, shouldRedirect]);
};
